type Variable = {
  name: string;
  value: any;
};

export const variablesFormatter: (value: Array<Variable>) => string = (value: Array<Variable>) => {
  if (value) {
    const target = value.map(variable => {
      return `"${variable.name}":${JSON.stringify(variable.value)}`;
    }).join(',');

    return `{${target}}`;
  } else {
    return '';
  }
};
